import { campaignsCommand } from "./campaigns.js";
import { connectCommand } from "./connect.js";
import { contactsCommand } from "./contacts.js";
import { devCommand } from "./dev.js";
import { doctorCommand } from "./doctor.js";
import { domainCommand } from "./domain.js";
import { ejectCommand } from "./eject.js";
import { emailsCommand } from "./emails.js";
import { eventsCommand } from "./events.js";
import { hatchetCommand } from "./hatchet.js";
import { importCommand } from "./import.js";
import { journeysCommand } from "./journeys.js";
import { patchCommand } from "./patch.js";
import { setupCommand } from "./setup.js";
import { skillsCommand } from "./skills.js";
import { statsCommand } from "./stats.js";
import { studioCommand } from "./studio.js";
import type { Command } from "./types.js";
import { upgradeCommand } from "./upgrade.js";
import { webhooksCommand } from "./webhooks.js";

/**
 * The command registry. The router (src/bin.ts) matches the leading argv token
 * against each `command.name` and dispatches to `run()`.
 *
 * Order here is the order shown in root help. Data commands (agent-native,
 * wrapping the engine's /v1/admin/* routes) come first, then the local
 * scaffolding/maintenance commands (setup, skills, eject, patch).
 */
export const commands: Command[] = [
  doctorCommand,
  journeysCommand,
  contactsCommand,
  importCommand,
  statsCommand,
  eventsCommand,
  emailsCommand,
  campaignsCommand,
  webhooksCommand,
  domainCommand,
  connectCommand,
  hatchetCommand,
  studioCommand,
  devCommand,
  setupCommand,
  skillsCommand,
  upgradeCommand,
  ejectCommand,
  patchCommand,
];

export type { Command, CommandContext } from "./types.js";
